import type { OptionProps, Option } from '@usealloy/component-library';
import { MultiSelectComponents } from '@usealloy/component-library';

import type { ActionOptionMeta } from '../types';
import Content from './Content';


interface AddLinkedChildActionOptionProps<T> extends OptionProps<T, false> { }

export default function AddLinkedChildActionOption<T extends Option<ActionOptionMeta>>(
  props: AddLinkedChildActionOptionProps<T>,
) {
  return (
    <MultiSelectComponents.Option {...props}>
      <Content<T> {...props} showIcon />
    </MultiSelectComponents.Option>
  );
}
